import {useCsat} from '@adv-mt/mt-tracking-use-csat'

import {useNavigationC2bCreateAppointment} from '../components/c2b/useNavigationC2bCreateAppointment.js'
import {FeatureNotAvailableModal} from '../components/featureNotAvailableModal.js'
import {ReservationMoreInfo} from '../components/reservation/reservationMoreInfo/index.js'
import {ReservationPaymentStatusModal} from '../components/reservation/reservationPaymentStatusModal/index.js'
import {useNavigationReservationPayment} from '../components/reservation/reservationRedirectPayment/useNavigationReservationPayment.js'
import {ModalTransactionAccept} from '../components/transaction/acceptTransactionModal.js'
import {BuyerCancelledContractsTransactionModal} from '../components/transaction/buyerCancelledContractsTransactionModal.js'
import {BuyerCancelledIdBuyerTransactionModal} from '../components/transaction/buyerCancelledIdTransactionModal.js'
import {BuyerCancelledVehicleTransactionModal} from '../components/transaction/buyerCancelledVehicleTransactionModal.js'
import {BuyerCheckContractsTransactionModal} from '../components/transaction/buyerCheckContractsTransactionModal.js'
import {BuyerCheckDocumentsTransactionModal} from '../components/transaction/buyerCheckDocumentsTransactionModal.js'
import {BuyerDeliveryKoReasonsTransactionModal} from '../components/transaction/buyerDeliveryKoReasonsTransactionModal.js'
import {BuyerIdentityTransactionModal} from '../components/transaction/buyerIdentityTransactionModal.js'
import {BuyerPaymentBlockedReasonsTransactionModal} from '../components/transaction/buyerPaymentBlockedReasonsTransactionModal.js'
import {BuyerPaymentFailTransactionModal} from '../components/transaction/buyerPaymentFailTransactionModal.js'
import {BuyerPaymentSuccessTransactionModal} from '../components/transaction/buyerPaymentSuccessTransactionModal.js'
import {BuyerStartingPaymentTransactionModal} from '../components/transaction/buyerStartingPaymentTransactionModal.js'
import {ConfirmCostsListTransactionModal} from '../components/transaction/confirmCostsListTransactionModal.js'
import {ConfirmPriceTransactionModal} from '../components/transaction/confirmPriceTransactionModal.js'
import {ConfirmTermsAndConditionsTransactionModal} from '../components/transaction/confirmTermsAndConditionsTransactionModal.js'
import {ExternalInteractionTransactionModal} from '../components/transaction/externalInteractionTransactionModal.js'
import {InformPriceTransactionModal} from '../components/transaction/informPriceTransactionModal.js'
import {RefundReservationSuccessTransactionModal} from '../components/transaction/refundReservationSuccessTransactionModal.js'
import {RejectedPriceTransactionModal} from '../components/transaction/rejectedPriceTransactionModal.js'
import {ReservationInfoTransactionModal} from '../components/transaction/reservationInfoTransactionModal.js'
import {ReservationPaymentSuccessDrawer} from '../components/transaction/reservationPaymentSuccessDrawer.js'
import {SellerCancelledContractsTransactionModal} from '../components/transaction/sellerCancelledContractsTransactionModal.js'
import {SellerCancelledIdTransactionModal} from '../components/transaction/sellerCancelledIdTransactionModal.js'
import {SellerCancelledVehicleTransactionModal} from '../components/transaction/sellerCancelledVehicleTransactionModal.js'
import {SellerCheckContractsTransactionModal} from '../components/transaction/sellerCheckContractsTransactionModal.js'
import {SellerCheckDocumentsTransactionModal} from '../components/transaction/sellerCheckDocumentsTransactionModal.js'
import {SellerDeliveryKoReasonsTransactionModal} from '../components/transaction/sellerDeliveryKoReasonsTransactionModal.js'
import {SellerIdentityTransactionModal} from '../components/transaction/sellerIdentityTransactionModal.js'
import {useNavigationTransactionBuyerCheckCostsList} from '../components/transaction/useNavigationTransactionBuyerCheckCostsList.js'
import {useNavigationTransactionBuyerConfirmPrice} from '../components/transaction/useNavigationTransactionBuyerConfirmPrice.js'
import {useNavigationTransactionBuyerIdentity} from '../components/transaction/useNavigationTransactionBuyerIdentity.js'
import {useNavigationTransactionBuyerInitPayment} from '../components/transaction/useNavigationTransactionBuyerInitPayment.js'
import {useNavigationTransactionRefundReservation} from '../components/transaction/useNavigationTransactionRefundReservation.js'
import {useNavigationTransactionSellerIdentity} from '../components/transaction/useNavigationTransactionSellerIdentity.js'
import {useNavigationTransactionSellerPrice} from '../components/transaction/useNavigationTransactionSellerPrice.js'
import {WithdrawalReasonsTransactionModal} from '../components/transaction/withdrawalReasonsTransactionModal.js'
import {FEATURE_NOT_AVAILABLE_INTERACTION, getInteractionId} from './utils.js'

const ROUTER_STATE_INTERACTIONS = {
  SHOW_TRANSACTION_CONFIRM_COSTS_LIST_MODAL: 'showConfirmCostsListTransactionModal',
  SHOW_TRANSACTION_BUYER_IDENTITY_MODAL: 'showTransactionBuyerIdentityModal',
  SHOW_TRANSACTION_BUYER_PAYMENT_FAIL_MODAL: 'showTransactionBuyerPaymentFailModal',
  SHOW_TRANSACTION_BUYER_PAYMENT_SUCCESS_MODAL: 'showTransactionBuyerPaymentSuccessModal',
  SHOW_TRANSACTION_PRICE_CONFIRMED_MODAL: 'showTransactionPriceConfirmedModal',
  SHOW_TRANSACTION_PRICE_REJECTED_MODAL: 'showTransactionPriceRejectedModal',
  SHOW_TRANSACTION_PRICE_AGREED_MODAL: 'showTransactionPriceAgreedModal',
  SHOW_TRANSACTION_SELLER_IDENTITY_MODAL: 'showTransactionSellerIdentityModal',
  SHOW_TRANSACTION_CONFIRM_TERMS_AND_CONDITIONS_MODAL: 'showTransactionConfirmTermsAndConditionsModal',
  SHOW_RESERVATION_PAYMENT_STATUS_MODAL: 'showReservationPaymentStatusModal',
  SHOW_RESERVATION_PAYMENT_SUCCESS_MODAL: 'showReservationPaymentSuccessModal',
  SHOW_RESERVATION_CONFIRMED_MODAL: 'showReservationConfirmedModal',
  SHOW_REFUND_RESERVATION_SUCCESS_MODAL: 'showRefundReservationSuccessModal'
}

const PAYCAR_SURVEYS_IDS = {
  SURVEY_PAYCAR_SELLER_COMPLETED: 'paycar_seller_completed',
  SURVEY_PAYCAR_BUYER_COMPLETED: 'paycar_buyer_completed',
  SURVEY_PAYCAR_SELLER_SELLER_CANCELED: 'paycar_seller_sellerCancels',
  SURVEY_PAYCAR_BUYER_BUYER_CANCELED: 'paycar_buyer_buyerCancels',
  SURVEY_PAYCAR_SELLER_BUYER_CANCELED: 'paycar_seller_buyerCancels',
  SURVEY_PAYCAR_BUYER_SELLER_CANCELED: 'paycar_buyer_sellerCancels',
  SURVEY_PAYCAR_SELLER_AUTOMATIC_CANCELED: 'paycar_seller_automaticCancel',
  SURVEY_PAYCAR_BUYER_AUTOMATIC_CANCELED: 'paycar_buyer_automaticCancel'
}

const RESERVATION_SURVEY_ID = {
  SURVEY_REFUND_RESERVATION: 'reserva_buyer_completed'
}

const surveyCallbacks = {
  'transaction-seller-survey-paycar-seller-completed': PAYCAR_SURVEYS_IDS.SURVEY_PAYCAR_SELLER_COMPLETED,
  'transaction-buyer-survey-paycar-buyer-completed': PAYCAR_SURVEYS_IDS.SURVEY_PAYCAR_BUYER_COMPLETED,
  'transaction-seller-survey-paycar-seller-sellerCancels': PAYCAR_SURVEYS_IDS.SURVEY_PAYCAR_SELLER_SELLER_CANCELED,
  'transaction-buyer-survey-paycar-buyer-buyerCancels': PAYCAR_SURVEYS_IDS.SURVEY_PAYCAR_BUYER_BUYER_CANCELED,
  'transaction-seller-survey-paycar-seller-buyerCancels': PAYCAR_SURVEYS_IDS.SURVEY_PAYCAR_SELLER_BUYER_CANCELED,
  'transaction-buyer-survey-paycar-buyer-sellerCancels': PAYCAR_SURVEYS_IDS.SURVEY_PAYCAR_BUYER_SELLER_CANCELED,
  'transaction-seller-survey-paycar-seller-automaticCancel': PAYCAR_SURVEYS_IDS.SURVEY_PAYCAR_SELLER_AUTOMATIC_CANCELED,
  'transaction-buyer-survey-paycar-buyer-automaticCancel': PAYCAR_SURVEYS_IDS.SURVEY_PAYCAR_BUYER_AUTOMATIC_CANCELED
}

export const useInteractionsConfig = routerState => {
  const redirectBuyerIdentity = useNavigationTransactionBuyerIdentity()
  const redirectBuyerCheckCostsList = useNavigationTransactionBuyerCheckCostsList()
  const redirectBuyerConfirmPrice = useNavigationTransactionBuyerConfirmPrice()
  const redirectBuyerNavigationInitPayment = useNavigationTransactionBuyerInitPayment()
  const redirectSellerIdentity = useNavigationTransactionSellerIdentity()
  const redirectSellerInformPrice = useNavigationTransactionSellerPrice()
  const redirectBuyerRefundReservation = useNavigationTransactionRefundReservation()
  const redirectBuyerPaymentReservation = useNavigationReservationPayment()
  const redirectC2bCreateAppointment = useNavigationC2bCreateAppointment()

  const {forceTrigger} = useCsat()

  const surveysCallbackObject = Object.entries(surveyCallbacks).reduce((acc, [actionKey, surveyId]) => {
    acc[actionKey] = {
      callback: () => forceTrigger(surveyId),
      type: 'trigger'
    }
    return acc
  }, {})

  const interactionObject = {
    [FEATURE_NOT_AVAILABLE_INTERACTION]: {callback: () => <FeatureNotAvailableModal />, type: 'component'},
    'transaction-buyer-check-contracts': {callback: () => <BuyerCheckDocumentsTransactionModal />, type: 'component'},
    'transaction-buyer-check-contracts-sent': {
      callback: () => <BuyerCheckContractsTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-payment-process-info': {
      callback: () => <BuyerStartingPaymentTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-confirm-price-agreed': {
      callback: redirectBuyerConfirmPrice,
      type: 'function'
    },
    'transaction-buyer-buyer-identity-ko-reasons': {
      callback: () => <BuyerCancelledIdBuyerTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-check-costs-list': {
      callback: redirectBuyerCheckCostsList,
      type: 'function'
    },
    'reservation-buyer-refund-reservation': {
      callback: redirectBuyerRefundReservation,
      type: 'function'
    },
    'transaction-buyer-contracts-ko': {
      callback: () => <BuyerCancelledContractsTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-delivery': {callback: () => <ExternalInteractionTransactionModal />, type: 'component'},
    'transaction-buyer-delivery-ko-reasons': {
      callback: () => <BuyerDeliveryKoReasonsTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-payback-reasons': {
      callback: () => <BuyerDeliveryKoReasonsTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-conditioned-refund-reasons': {
      callback: () => <BuyerDeliveryKoReasonsTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-init-payment': {
      callback: redirectBuyerNavigationInitPayment,
      type: 'function'
    },
    'transaction-buyer-payment-blocked-reasons': {
      callback: () => <BuyerPaymentBlockedReasonsTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-payout-release': {callback: () => <ExternalInteractionTransactionModal />, type: 'component'},
    'transaction-buyer-seller-identity-ko-reasons': {
      callback: () => <BuyerCancelledIdBuyerTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-vehicle-ko-reasons': {
      callback: () => <BuyerCancelledVehicleTransactionModal />,
      type: 'component'
    },
    'transaction-buyer-verify-identity': {
      callback: redirectBuyerIdentity,
      type: 'function'
    },
    'transaction-buyer-withdrawal': {
      callback: () => <ExternalInteractionTransactionModal showHeader />,
      type: 'component'
    },
    'transaction-buyer-withdrawal-reasons': {
      callback: () => <WithdrawalReasonsTransactionModal />,
      type: 'component'
    },
    'transaction-seller-buyer-identity-ko-reasons': {
      callback: () => <SellerCancelledIdTransactionModal />,
      type: 'component'
    },
    'transaction-seller-check-contracts': {callback: () => <SellerCheckDocumentsTransactionModal />, type: 'component'},
    'transaction-seller-check-contracts-sent': {
      callback: () => <SellerCheckContractsTransactionModal />,
      type: 'component'
    },
    'transaction-seller-contracts-ko': {
      callback: () => <SellerCancelledContractsTransactionModal />,
      type: 'component'
    },
    'transaction-seller-discover': {callback: () => <ModalTransactionAccept />, type: 'component'},
    'transaction-seller-delivery': {callback: () => <ExternalInteractionTransactionModal />, type: 'component'},
    'transaction-seller-delivery-ko-reasons': {
      callback: () => <SellerDeliveryKoReasonsTransactionModal />,
      type: 'component'
    },
    'transaction-seller-payback-reasons': {
      callback: () => <SellerDeliveryKoReasonsTransactionModal />,
      type: 'component'
    },
    'transaction-seller-seller-identity-ko-reasons': {
      callback: () => <SellerCancelledIdTransactionModal />,
      type: 'component'
    },
    'transaction-seller-inform-price-agreed': {
      callback: redirectSellerInformPrice,
      type: 'function'
    },
    'transaction-seller-verify-identity': {
      callback: redirectSellerIdentity,
      type: 'function'
    },
    'transaction-seller-vehicle-ko-reasons': {
      callback: () => <SellerCancelledVehicleTransactionModal />,
      type: 'component'
    },
    'transaction-seller-withdrawal': {
      callback: () => <ExternalInteractionTransactionModal showHeader />,
      type: 'component'
    },
    'transaction-seller-withdrawal-reasons': {
      callback: () => <WithdrawalReasonsTransactionModal />,
      type: 'component'
    },
    'reservation-buyer-reservation-details': {callback: () => <ReservationInfoTransactionModal />, type: 'component'},
    'reservation-buyer-survey-reservation-feedback': {
      callback: () => forceTrigger(RESERVATION_SURVEY_ID.SURVEY_REFUND_RESERVATION),
      type: 'trigger'
    },
    'reservation-buyer-more-info': {
      callback: () => <ReservationMoreInfo />,
      type: 'component'
    },
    'reservation-buyer-reserve': {callback: redirectBuyerPaymentReservation, type: 'function'},
    'c2b-seller-create-appointment': {callback: redirectC2bCreateAppointment, type: 'function'},

    ...surveysCallbackObject
  }

  const getInteractionsConfig = (url, params) => {
    const interactionId = getInteractionId(url)

    return interactionObject[interactionId]
  }

  const getForcedInteractionsConfig = query => {
    const interactionId = query.interaction

    return interactionObject[interactionId]
  }

  const stateInteractionObject = {
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_CONFIRM_COSTS_LIST_MODAL]: {
      callback: () => <ConfirmCostsListTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_CONFIRM_TERMS_AND_CONDITIONS_MODAL]: {
      callback: () => <ConfirmTermsAndConditionsTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_IDENTITY_MODAL]: {
      callback: () => <BuyerIdentityTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_PAYMENT_FAIL_MODAL]: {
      callback: () => <BuyerPaymentFailTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_PAYMENT_SUCCESS_MODAL]: {
      callback: () => <BuyerPaymentSuccessTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_AGREED_MODAL]: {
      callback: () => <InformPriceTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_CONFIRMED_MODAL]: {
      callback: () => <ConfirmPriceTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_REJECTED_MODAL]: {
      callback: () => <RejectedPriceTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_SELLER_IDENTITY_MODAL]: {
      callback: () => <SellerIdentityTransactionModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_RESERVATION_PAYMENT_STATUS_MODAL]: {
      callback: () => <ReservationPaymentStatusModal />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_RESERVATION_PAYMENT_SUCCESS_MODAL]: {
      callback: () => <ReservationPaymentSuccessDrawer />,
      type: 'component'
    },
    [ROUTER_STATE_INTERACTIONS.SHOW_REFUND_RESERVATION_SUCCESS_MODAL]: {
      callback: () => <RefundReservationSuccessTransactionModal />,
      type: 'component'
    }
  }

  // React Router 7 sets location.state to null on a plain load, which a default parameter does not cover.
  const getStateInteractionsConfig = locationState => {
    const state = locationState ?? {}
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_CONFIRM_COSTS_LIST_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_CONFIRM_COSTS_LIST_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_CONFIRM_TERMS_AND_CONDITIONS_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_CONFIRM_TERMS_AND_CONDITIONS_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_CONFIRMED_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_CONFIRMED_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_REJECTED_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_REJECTED_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_AGREED_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_PRICE_AGREED_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_IDENTITY_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_IDENTITY_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_SELLER_IDENTITY_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_SELLER_IDENTITY_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_PAYMENT_FAIL_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_PAYMENT_FAIL_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_PAYMENT_SUCCESS_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_TRANSACTION_BUYER_PAYMENT_SUCCESS_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_RESERVATION_CONFIRMED_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_RESERVATION_CONFIRMED_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_RESERVATION_PAYMENT_STATUS_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_RESERVATION_PAYMENT_STATUS_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_RESERVATION_PAYMENT_SUCCESS_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_RESERVATION_PAYMENT_SUCCESS_MODAL]
    if (state[ROUTER_STATE_INTERACTIONS.SHOW_REFUND_RESERVATION_SUCCESS_MODAL])
      return stateInteractionObject[ROUTER_STATE_INTERACTIONS.SHOW_REFUND_RESERVATION_SUCCESS_MODAL]
    return {}
  }

  return {getForcedInteractionsConfig, getInteractionsConfig, getStateInteractionsConfig}
}
